import cookie from '../lib/treffcook';

export default class CookiesRules {
  constructor(el) {
    this.el = el;
    this.isLanding = parseInt(this.el.getAttribute('data-il'), 10);
    if (!document.cookie.includes('_notracking')) {
      cookie.Set('_notracking', 1, 30);
    }
    this.confirmBtn = document.querySelector('#confirm-btn');
    this.configBtn = document.querySelector('#config-btn');
    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    const cStatus = cookie.Get('_epr');
    if (this.isLanding === 1) {
      if (!cStatus || cStatus !== '3e4d891a5df3d6d0d7dd9432a1bc6470') {
        this.el.closest('#cookies-conditions').removeAttribute('style');
      }
    } else {
      $(window).on('load', () => {
        if (!cStatus || cStatus !== '3e4d891a5df3d6d0d7dd9432a1bc6470') {
          $('#cookies-conditions-bg').show();
          $('#cookies-conditions').show();
        }
      });
    }
    $('body').on('click', '#config-btn', () => {
      $('#back-btn').show();
      $('.step-1').hide();
      $('.step-2').show();
    });
    $('body').on('click', '#back-btn', () => {
      $('.step-1').show();
      $('.step-2').hide();
      $('#back-btn').hide();
    });
    $('body').on('click', '#confirm-btn', () => {
      $.ajax({
        url: '/ajax.php',
        method: 'POST',
        type: 'json',
        data: {
          mode: 'ePrGDPR',
          action: 'a'
        },
        success: response => {
          const result = $.parseJSON(response);
          window.consentGranted(true, true, 'Grant all');
          cookie.Set('_notracking', 0, 30);
          cookie.Set('_epr', result.all, 30);
          cookie.Set('_epr_stat', result.stat, 30);
          cookie.Set('_epr_mar', result.mar, 30);
          $('#cookies-conditions').hide();
          $('#cookies-conditions-bg').hide();
        }
      });
    });
    $('body').on('click', '#save-btn', () => {
      const valMar = $('input[name=mar]').is(':checked');
      const valFun = $('input[name=fun]').is(':checked');
      $.ajax({
        url: '/ajax.php',
        method: 'POST',
        type: 'json',
        data: {
          mode: 'ePrGDPR',
          action: 's',
          mar: valMar,
          stat: valFun
        },
        success: response => {
          const result = $.parseJSON(response);
          const consentStatistics = result.statistics;
          const consentMarketing = result.marketing;
          window.consentGranted(
            consentStatistics,
            consentMarketing,
            'Grant selected'
          );
          cookie.Set('_epr', result.all, 30);
          cookie.Set('_epr_stat', result.stat, 30);
          if (result.stat !== 0) {
            cookie.Set('_notracking', 0, 30);
          } else {
            cookie.Set('_notracking', 1, 30);
          }
          cookie.Set('_epr_mar', result.mar, 30);
          $('#cookies-conditions').hide();
          $('#cookies-conditions-bg').hide();
        }
      });
    });
  }
  /* eslint-enable class-methods-use-this */
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/cookies_rules.js